import React from "react";
import styles from "./style.module.scss";
import Box from "@amzn/meridian/box";
import { IVerticalLineProps } from "./definitions";

export const VerticalLine: React.FC<IVerticalLineProps> = ({ height }) => {
    return (
        <Box
            className={styles.verticalLine}
            tag={"div"}
            minHeight={height ?? 1}
            maxHeight={height}
        ></Box>
    );
};
